import * as React from "react";
import PropTypes from 'prop-types';

const SvgHambCloseApollo = props => {
  if (props.id !== "_svghambcloseapollo") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 18 18" {...props}><path fill="#202020" fillRule="evenodd" d="M14.702 2.43a.613.613 0 11.868.868L9.868 9l5.702 5.702a.614.614 0 01.048.815l-.048.053a.613.613 0 01-.868 0L9 9.868 3.298 15.57a.614.614 0 01-.815.048l-.053-.048a.613.613 0 010-.868L8.132 9 2.43 3.298a.614.614 0 01-.048-.815l.048-.053a.613.613 0 01.868 0L9 8.132l5.702-5.702z" /></svg>;
};

SvgHambCloseApollo.displayName = "_svghambcloseapollo";
SvgHambCloseApollo.propTypes = {
  id: PropTypes.string
};
SvgHambCloseApollo.defaultProps = {
  id: ''
};
export default SvgHambCloseApollo;